import { createQuery } from '@tanstack/svelte-query';
import { fetchDinModules } from '$lib/api/din_module';
import { fetchRCUs } from '$lib/api/rcu';
import type { DinModuleResponse } from '$lib/types/din_module';
import { resolveScope, getUnitScope, type ScopeFn } from './scope';

export const dinModulesQuery = (scope: ScopeFn) =>
	createQuery<Array<DinModuleResponse>>(() => {
		const rcuId = resolveScope(scope);
		return {
			queryKey: ['din_modules', { rcuId }],
			queryFn: async () => {
				const all = await fetchDinModules();
				return all.filter((m) => m.rcu === rcuId);
			},
			enabled: rcuId > 0
		};
	});

export const dinModulesForUnitQuery = (scope: ScopeFn = getUnitScope()) =>
	createQuery<Array<DinModuleResponse>>(() => {
		const unitId = resolveScope(scope);
		return {
			queryKey: ['din_modules', { unitId }],
			queryFn: async () => {
				const [allDinModules, allRcus] = await Promise.all([fetchDinModules(), fetchRCUs()]);
				const rcuIds = new Set(allRcus.filter((r) => r.unit === unitId).map((r) => r.id));
				return allDinModules.filter((m) => rcuIds.has(m.rcu));
			},
			enabled: unitId > 0
		};
	});
